import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {DownloadAppReminderContent} from "../Components/downloadAppReminderContent.jsx";

export function DownloadAppReminder({setStep, closeModal}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={null} showBackButton={false} setStep={setStep} closeModal={closeModal}/>
            <div className="modalPages-spacing pb-8">
                <DownloadAppReminderContent onDone={() => setStep('paymentCards')}/>
            </div>
        </>
    );
}
export default DownloadAppReminder;
